export default __webpack_public_path__ + "static/media/developer 2.52d0a3fb.png";